import { FETCH_METER_LIST, SET_CHARGEAREA_LIST, SET_GA_LIST, SET_METER_LIST, SET_PR0JECT_LIST, SET_RESPONSE_DATA, SET_SPV_LIST } from "../actions/meterList";

const initialState = {
  meterList: null,
  projectList: null
}

const meterListReducer = (state = initialState, action) => {

  switch (action.type) {
    case SET_METER_LIST:

      return {
        ...state,
        meterList: action.payload
      }
    case SET_SPV_LIST:
      return {
        ...state,
        spvList: action.payload
      }
    case SET_GA_LIST:
      return {
        ...state,
        gaList: action.payload
      }
    case SET_CHARGEAREA_LIST:
      return {
        ...state,
        chargeareaList: action.payload
      }
    case SET_PR0JECT_LIST:
      return {
        ...state,
        projectList: action.payload
      }
    case SET_RESPONSE_DATA:
      return {
        ...state,
        responseData: action.payload
      }
    case FETCH_METER_LIST:
      return {
        ...state,
        fetchList: action.payload
      }
    default:
      return state
  }
}

// const userSessionDataReducer =()

export default meterListReducer